/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import constants from "@/constants.js";
import { dispatch } from "d3";

export default {
  //////////////////////////////
  /// Organization Specific
  //////////////////////////////

  async createOrganization({ commit }, organizationObj) {
    try {
      const payload = {
        userId: organizationObj.userId,
        name: organizationObj.name,
        slug: organizationObj.slug,
        website: organizationObj.website,
        logo: organizationObj.logo,
        olObj: organizationObj.olObj,
        workEmail: organizationObj.workEmail,
        organizationType: organizationObj.organizationType,
        location: organizationObj.location,
        primaryThemeColor: organizationObj.primaryThemeColor,
        secondaryThemeColor: organizationObj.secondaryThemeColor,
        organizationCulture: organizationObj.organizationCulture,
        about: organizationObj.about,
      };

      const resObj = await axios.post(
        `${constants.apiHost}/organization`,
        payload
      );
      commit("SET_ORGANIZATION", resObj.data);

      // log activity
      payload["organizationId"] = resObj.data._id;
      const logText = `Created a new Organization - ${payload.name}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...payload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganization({ commit }, _id) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/organization/${_id}`
      );
      commit("SET_ORGANIZATION", resObj.data);
      // // console.log(resObj);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationById({ commit }, _id) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/organization/${_id}`
      );
      commit("SET_ORGANIZATION", resObj.data);
      // // console.log(resObj);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationByUserId({ commit }, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, {
        params: { userId },
      });
      commit("SET_ORGANIZATION", resObj.data.data[0]);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationBySlug({ commit }, slug) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, {
        params: { slug },
      });
      commit("SET_ORGANIZATION", resObj.data.data[0]);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async importUser({ commit }, payload) {
    try {
      const resObj = await axios.post(`${constants.gatewayServiceUrl}/organization/employee/${payload.orgId}`, { ...payload.user, status: "ACTIVE" });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async checkSlug({ commit }, slug) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/organization`, {
        params: { slug },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateOrganization({ commit }, organizationObj) {
    try {
      const _id = organizationObj._id;
      const orgPayload = {
        name: organizationObj.name,
        website: organizationObj.website,
        logo: organizationObj.logo,
        olObj: organizationObj.olObj,
        workEmail: organizationObj.workEmail,
        slug: organizationObj.slug,
        organizationType: organizationObj.organizationType,
        location: organizationObj.location,
        primaryThemeColor: organizationObj.primaryThemeColor,
        secondaryThemeColor: organizationObj.secondaryThemeColor,
        organizationCulture: organizationObj.organizationCulture,
        about: organizationObj.about,
        organizationPrivacy: organizationObj.organizationPrivacy,
      };
      // console.log(orgPayload);
      const resObj = await axios.patch(
        `${constants.apiHost}/organization/${_id}`,
        orgPayload
      );
      commit("SET_ORGANIZATION", resObj.data);

      // log activity
      orgPayload["organizationId"] = resObj.data._id;
      const logText = `Updated Organization Details - ${orgPayload.name}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...orgPayload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async inviteOrganizationAdmin({ commit }, adminInviteObj) {
    try {
      const payload = {
        email: adminInviteObj.email,
        status: adminInviteObj.status,
        organizationId: adminInviteObj.organizationId,
        maxRole: adminInviteObj.maxRole,
      };
      const resObj = await axios.post(
        `${constants.apiHost}/organization-subadmins`,
        payload
      );
      commit("SET_ORGANIZATION_SUBADMIN", resObj.data);

      // send sub-admin invite email
      const mailPayload = {
        mailType: "organization-sub-admin-invitation",
        organizationName: adminInviteObj.organizationName,
        email: adminInviteObj.email,
      };
      // async
      axios.post(`${constants.apiHost}/mailer`, mailPayload);

      // log activity
      payload["organizationId"] = adminInviteObj.organizationId;
      const logText = `Added a new Sub-Admin - ${payload.email}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...payload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async revokeSubAdmin(
    { commit },
    { orgSubAdminId, subAdminEmail, organizationId }
  ) {
    try {
      const resObj = await axios.delete(
        `${constants.apiHost}/organization-subadmins/${orgSubAdminId}`
      );
      commit("REMOVE_ORGANIZATION_SUBADMIN", orgSubAdminId);

      // log activity
      const logPayload = {};
      logPayload["organizationId"] = organizationId;
      const logText = `Removed a Sub-Admin - ${subAdminEmail}`;
      axios.post(`${constants.apiHost}/actvt-log`, { logText, ...logPayload });

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationAdminByEmail({ commit }, adminObj) {
    try {
      const params = {
        email: adminObj.email,
        organizationId: adminObj.organizationId,
      };

      const resObj = await axios.get(
        `${constants.apiHost}/organization-subadmins`,
        { params }
      );

      // fetch organization sub-admins
      const organizationId = params.organizationId;
      const orgResObj = await axios.get(
        `${constants.apiHost}/organization/${organizationId}`
      );
      resObj.data["organization"] = orgResObj.data;

      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchSubAdminByEmailOrgId({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const organizationId = orgObj.organizationId;
      const resObj = await axios.get(
        `${constants.apiHost}/organization-subadmins`,
        { params: { email, organizationId } }
      );
      return resObj;
    } catch {
      throw error;
    }
  },
  async checkAlexAdminByEmail({ commit }, adminObj) {
    try {
      const params = {
        email: adminObj.email,
      };

      const resObj = await axios.get(
        `${constants.apiHost}/organization-subadmins`,
        { params }
      );
      // fetch organization sub-admins
      // // console.log(resObj.data);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllMyOrganizations({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const userId = orgObj.userId;
      const subResObj = await axios.get(
        `${constants.apiHost}/organization-subadmins`,
        { params: { email } }
      );
      const superResObj = await axios.get(`${constants.apiHost}/organization`, {
        params: { userId },
      });
      // const allOrgs = {
      //   superOrgs: superResObj.data.data.filter(
      //     (org) => org.status === true || org.status === "ACTIVE"
      //   ),
      //   subOrgs: subResObj.data.data.filter((org) => org.status === "active"),
      // };
      const allOrgs = {
        superOrgs: superResObj.data.data,
        subOrgs: subResObj.data.data
      };
      commit("SET_MY_ORGANIZATIONS", allOrgs);
      return allOrgs;
    } catch (error) {
      throw error;
    }
  },
  async onlyFetchAllMyOrganizations({ commit }, orgObj) {
    try {
      const email = orgObj.email;
      const userId = orgObj.userId;
      const subResObj = await axios.get(
        `${constants.apiHost}/organization-subadmins`,
        { params: { email } }
      );
      const superResObj = await axios.get(`${constants.apiHost}/organization`, {
        params: { userId },
      });
      const allOrgs = {
        superOrgs: superResObj.data.data,
        subOrgs: subResObj.data.data,
      };
      // // console.log(allOrgs);
      // commit('SET_MY_ORGANIZATIONS', allOrgs);
      return allOrgs;
    } catch (error) {
      throw error;
    }
  },
  async acceptAdminOrgInvite({ commit }, adminObj) {
    try {
      const adminId = adminObj.adminId;
      const status = "active";
      const resObj = await axios.patch(
        `${constants.apiHost}/organization-subadmins/${adminId}`,
        { status }
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrgActivityLogData({ commit }, { organizationId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/actvt-log`, {
        params: { organizationId },
      });
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  async logOrganizationActivity({ commit }, { logObj, organizationId }) {
    try {
      let payload = logObj;
      // log activity
      payload["organizationId"] = organizationId;
      if (payload.logText && payload["organizationId"]) {
        axios.post(`${constants.apiHost}/actvt-log`, payload);
      }
    } catch (err) {
      throw err;
    }
  },
  async fetchAllRktSubscriptions({ commit }, { subsObj, orgSlug }) {
    try {
      if (orgSlug) {
        const subscriptions = await axios.get(
          `${constants.commServiceUrl}/rkt/${orgSlug}/subscriptions/${subsObj.userId}`
        );
        return subscriptions.data.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async checkCommServerStatus({ commit }, { orgSlug }) {
    try {
      if (orgSlug) {
        const commSetup = await axios.get(
          `${constants.commServiceUrl}/rkt/${orgSlug}/setup`
        );
        return commSetup.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async saveCoachConfig({ commit }, coachConfigDetails) {
    try {
      const organizationId = coachConfigDetails.organizationId;
      const resObj = await axios.patch(
        `${constants.apiHost}/organization/${organizationId}`,
        coachConfigDetails
      );
      commit(
        "SAVE_COACH_CONFIGS",
        coachConfigDetails["appConfigs.coach"] ||
        coachConfigDetails["appConfigs"]["coach"]
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveHibobConfig({ commit }, hibobConfigDetails) {
    try {
      const organizationId = hibobConfigDetails.organizationId;
      const resObj = await axios.patch(
        `${constants.apiHost}/organization/${organizationId}`,
        hibobConfigDetails
      );
      commit(
        "SAVE_HIBOB_CONFIGS",
        hibobConfigDetails["appConfigs.hibob"] ||
        hibobConfigDetails["appConfigs"]["hibob"]
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////////////
  // Organization API Keys
  /////////////////////////////
  async fetchAllAPIKeys({ commit }, { organizationId }) {
    try {
      if (organizationId) {
        const apiKeys = await axios.get(
          `${constants.connServiceUrl}/client/${organizationId}`
        );
        return apiKeys.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async issueAPIKey({ commit }, { organizationId, label, userId }) {
    try {
      if (organizationId && label && userId) {
        const apiKey = await axios.post(
          `${constants.connServiceUrl}/client/issue-key`,
          {
            organizationId,
            label,
            userId,
          }
        );
        return apiKey.data.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async revokeAPIKey({ commit }, { apiKeyId }) {
    try {
      if (apiKeyId) {
        const apiKeys = await axios.delete(
          `${constants.connServiceUrl}/client/revoke/${apiKeyId}`
        );
        return apiKeys.data.data;
      }
    } catch (err) {
      throw err;
    }
  },

  /////////////////////////////
  // Organization Funds
  /////////////////////////////
  async fetchAllTransactions({ commit }, { organizationId }) {
    try {
      if (organizationId) {
        const transactions = await axios.get(
          `${constants.apiHost}/organization-funds`,
          { params: { organizationId } }
        );
        return transactions.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async addFunds(
    { commit },
    { organizationId, userId, amount, currency, referenceId, fundType }
  ) {
    try {
      if (
        organizationId &&
        userId &&
        amount &&
        currency &&
        referenceId &&
        fundType
      ) {
        const transaction = await axios.post(
          `${constants.apiHost}/organization-funds`,
          {
            organizationId,
            userId,
            amount,
            currency,
            referenceId,
            fundType,
          }
        );
        return transaction.data.data;
      }
      throw "Incomplete Info";
    } catch (err) {
      throw err;
    }
  },

  /////////////////////////////
  // Organization Employees
  /////////////////////////////
  async patchEmployee(_, payload) {
    try {
      const resObj = await axios.patch(
        `${constants.gatewayServiceUrl}/organization/employee/${payload["employeeId"]}`, payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async addEmployee({commit,dispatch}, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/organization/employee/${payload.organizationId}`, payload
      );
      if(resObj.data.data._id){
        const details = resObj.data.data;
        const newEmployee = await dispatch('fetchEmployee',{
            organizationId : payload.organizationId,
            userId : details.userId
        });        
        // commit('ADD_EMPLOYEE', resObj.data.data);
      }
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchEmployee(_, { organizationId, userId }) {
    try {
      if (organizationId) {
        const employees = await axios.get(
          `${constants.gatewayServiceUrl}/organization/employee/${userId}`
        );
        return employees.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async fetchAllEmployees({ commit }, { organizationId }) {
    try {
      if (organizationId) {
        const employees = await axios.get(
          `${constants.gatewayServiceUrl}/organization/employees/${organizationId}`
        );
        commit("SAVE_EMPLOYEES", employees.data.data);
        return employees.data.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async deactivateEmployee({ commit }, { employeeId }) {
    try {
      if (employeeId) {
        const employees = await axios.post(
          `${constants.gatewayServiceUrl}/organization/employee/deactivate/${employeeId}`
        );
        return employees.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },

  /////////////////////////////////
  // Organization Configuration
  /////////////////////////////////
  async setDefaultOrganizationConfig({ commit }, payload) {
    try {
      const orgConfig = await axios.post(
        `${constants.gatewayServiceUrl}/organization/organization-config`, payload
      );
      commit("SAVE_ORGANIZATION_CONFIGURATION", orgConfig.data.data);
      return orgConfig.data.data;
    } catch (err) {
      throw err;
    }
  },
  async fetchOrganizationConfig({ commit }, { organizationId }) {
    try {
      if (organizationId) {
        const orgConfig = await axios.get(
          `${constants.gatewayServiceUrl}/organization/organization-config/${organizationId}`
        );
        commit("SAVE_ORGANIZATION_CONFIGURATION", orgConfig.data.data);
        return orgConfig.data.data;
      }
      return {};
    } catch (err) {
      throw err;
    }
  },
  
  async updateOrganizationConfig({ commit }, payload) {
  try {
    const resObj = await axios.patch(
      `${constants.gatewayServiceUrl}/organization/organization-config/${payload.organizationId}`,
      payload.configuration
    );
    commit("SAVE_ORGANIZATION_CONFIGURATION", resObj.data.data);
    return resObj.data;
  } catch (err) {
    throw err;
  }
},

  async getAssignedOrganization(_, _id) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/organization/${_id}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async getEmployeeRequest(_, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/organization/employee-join-requests/${orgId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async requestStatus(_, payload) {
    try {
      const resObj = await axios.patch(
        `${constants.gatewayServiceUrl}/organization/employee/join-request/status`,
        payload
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  async getOrgBoards(_, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/boards/${orgId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getAllOrgEmployees(_, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/organization/employees/${orgId}`
      );
      // SAFETY CHECK: If network/CORS fails and returns undefined, fallback safely to prevent crashing
      return resObj ? resObj.data : { data: [] };
    } catch (error) {
      throw error;
    }
  },
  async saveEmployeeRelation(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/organization/employee-relationship`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async removeEmployeeRelationship(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/organization/employee-relationship/deactivate`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////
  // MarketPlace app///
  /////////////////////
  fetchUserDetails(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "https://api-core-gateway.getboarded.com/user/" + payload.accessToken
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchProducts(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.marketAdminUrl}/get-all-products?orgId=${payload.orgId}&userId=${payload.userId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((res) => {
          resolve(res.data.allProducts);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchOrgProductAndPriceTypes(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.gatewayServiceUrl}/organization/organization-config/${payload.orgId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((res) => {
          resolve([
            res.data.data.currency.values.filter(
              (currency) => currency.key !== 0
            ),
            res.data.data.marketProductType.values,
          ]);
        })
        .catch((err) => {
          // console.log(err);
          reject(err);
        });
    });
  },
  fetchUserOrgAccessLevel(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.gatewayServiceUrl}/organization/employee/${payload.orgId}/${payload.userId}`,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async addProductType(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.marketAdminUrl}/add-organisation-producttype?orgId=${payload.orgId}&userId=${payload.userId}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getOrgEmployeeVisualization(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/organization/employee-relationship/visualization/${payload}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  addProduct(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${constants.marketAdminUrl}/add-product?orgId=${payload.orgId}&userId=${payload.userId}`,
          payload.formData,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((result) => {
          if (result !== undefined)
            resolve(result.data.message || result.data.error);
          else reject(new Error("Try Reducing Image Size"));
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateProduct(_, payload) {
    // console.log("formdata:", payload.formData);
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${constants.marketAdminUrl}/update-product?id=${payload.id}&orgId=${payload.orgId}&userId=${payload.userId}`,
          payload.formData,
          {
            headers: {
              Authorization: `Bearer ${payload.accessToken}`,
            },
          }
        )
        .then((response) => {
          // console.log(response);
          resolve(response.data.message || response.data.error);
        })
        .catch((error) => {
          // console.log(error);
          reject(error.data.error);
        });
    });
  },
  deleteProduct(_, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${constants.marketAdminUrl}/delete-product?id=${payload.id}&orgId=${payload.orgId}&userId=${payload.userId}`,
          null,
          {
            headers: {
              Authorization: "Bearer " + payload.accessToken,
            },
          }
        )
        .then((response) => {
          // console.log(response);
          resolve(response.data.message || response.data.error);
        })
        .catch((error) => {
          // console.log(error);
          reject(error.data.error);
        });
    });
  },
  // questions in validations
  async createQuiz(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/quiz/question`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchQuiz(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/evaluation/quiz/${payload.orgId}/${payload.itemId}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async deleteQuestion(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/quiz/question/${payload}/delete`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateQuestion(_, payload) {
    try {
      const resObj = await axios.patch(
        `${constants.gatewayServiceUrl}/evaluation/quiz/question/${payload._id}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchQuizResult(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/evaluation/quiz/result/${payload.orgId}/${payload.userId}/${payload.itemId}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAttendanceToken(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/attendance/link-token`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUploadedDocument(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/document/retrieve`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async fetchOrganizationsByPrivacyType(_, privacyType) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/organization/privacy/${privacyType}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async uploadUsersFromExcel(_, payload) {
    const resObj = await axios.post(
      `${constants.gatewayServiceUrl}/organization/employee-import/upload-data/${payload.get("orgId")}`,
      payload
    );
    return resObj.data;
  },

  async deleteOrganization(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/organization/delete/${payload}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationsMembersCount(_, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/organization/employee-count/${orgId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationsFunds(_, orgId) {
    const resObj = await axios.get(
      `${constants.paymentsServiceUrl}/funds/${orgId}`
    );
    return resObj.data;
  },
  startResumeBatch({ commit }, batchId) {
    commit('SET_ACTIVE_RESUME_BATCH_ID', batchId);
    commit('SET_BATCH_PROGRESS', 0);  // Reset progress
  },
  
  updateBatchProgress({ commit }, progress) {
    commit('SET_BATCH_PROGRESS', progress);
  },


  updateResumeBatchStatus({ commit }, status) {
    commit('SET_RESUME_BATCH_STATUS', status);
  },
//   updateBatchProgress({ commit }, percentage) {
//     commit('UPDATE_BATCH_PROGRESS', percentage);
// },

  clearResumeBatch({ commit }) {
    commit('SET_ACTIVE_RESUME_BATCH_ID', null);
    commit('SET_ACTIVE_BATCH_PROGRESS', 0);
  },
  
  checkExistingResumeBatch({ dispatch }) {
    const existingBatchId = localStorage.getItem('activeResumeBatchId');
    if (existingBatchId) {
      dispatch('startResumeBatch', existingBatchId);
    }
  }
};
